/* RESPONSIBLE TEAM: team-app-security */
import * as ajax from 'embercom/lib/ajax';

const VALID_CONTEXTS = ['inbox_view', 'conversation_view', 'profile_view'] as const;
type ViewContext = (typeof VALID_CONTEXTS)[number];

export function trackConversationView(
  appId: string,
  conversationId: string | number,
  context: ViewContext,
  referrer?: string,
): void {
  if (!VALID_CONTEXTS.includes(context)) {
    return;
  }

  ajax
    .post('/ember/conversation_views', {
      app_id: appId,
      conversation_id: String(conversationId),
      context,
      referrer,
    })
    .catch(() => {});
}
